import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EmitDataService {
    constructor() {
        this.model = new EventEmitter();
        this.dataInput = new EventEmitter();
        this.paso = new EventEmitter();
        this.dato = new EventEmitter();
        this.datoBancario = new EventEmitter();
        this.valido = new EventEmitter();
        this.pagoCotizacion = new EventEmitter();
    }
    enviarModel(model) {
        this.model.emit(model);
    }
    enviarDataInput(dataInput) {
        this.dataInput.emit(dataInput);
    }
    enviarPaso(paso) {
        this.paso.emit(paso);
    }
    enviarDato(dato) {
        this.dato.emit(dato);
    }
    enviarDatosBancarios(datoBancario) {
        this.datoBancario.emit(datoBancario);
    }
    enviarValidez(valido) {
        this.valido.emit(valido);
    }
    enviarPagoCotizacion(data) {
        this.pagoCotizacion.emit(data);
    }
}
EmitDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EmitDataService_Factory() { return new EmitDataService(); }, token: EmitDataService, providedIn: "root" });
